<script lang="js" setup>
import { useWindowSize } from '@vueuse/core';

const props = defineProps({
    formData: {
        type: Object,
        required: true
    },
    mewsId: {
        type: String,
        required: true
    },
    mewsIds: {
        type: Array,
        required: false,
        default: () => []
    },
    location: {
        type: Object,
        default: () => {},
        required: false
    },
    roomId: {
        type: String,
        default: '',
        required: false
    },
});

onMounted(() => {
    if (!props.formData.date) {
        return;
    }

    const startYear = new Date(props.formData.date.start).getFullYear();
    const startMonth = new Date(props.formData.date.start).getMonth() + 1;
    const startDay = new Date(props.formData.date.start).getDate();

    const endYear = new Date(props.formData.date.end).getFullYear();
    const endMonth = new Date(props.formData.date.end).getMonth() + 1;
    const endDay = new Date(props.formData.date.end).getDate();
    
    let configurationIds = `[
        '${ props.mewsId }'
    ]`;

    if (props.mewsIds.length) {
        configurationIds = `[
            ${ props.mewsIds.map(id => `'${id}'`).join(', ') }
        ]`;
    }

    // Determine the appropriate voucher code
    // When user manually enters a code, this has priority
    // If no manual code is present, check for device-based fallbacks, these come from the CMS
    let code = props.formData?.code || null;
    const location = props.formData?.location || {};
    const hasManualCode = !! props.formData?.code;
    const hasMobileCode = !!location.mewsVoucherCodeMobile;
    const hasDesktopCode = !!location.mewsVoucherCodeDesktop;
    
    if (!hasManualCode && (hasMobileCode || hasDesktopCode)) {
        const { width } = useWindowSize();
        if (width.value < 768 && hasMobileCode) {
            code = location.mewsVoucherCodeMobile;
        } else if (width.value >= 768 && hasDesktopCode) {
            code = location.mewsVoucherCodeDesktop;
        }
    }

    useHead({
        script: [
            {
                src: 'https://api.mews.com/distributor/distributor.min.js'
            },
            {
                innerHTML: `Mews.Distributor({
                    configurationIds: ${configurationIds},
                },
                function(api) {
                    ${ props.formData?.date?.start ? `api.setStartDate(new Date(${startYear}, ${ Number(startMonth) - 1}, ${ Number(startDay) }));` : ''}

                    ${ props.formData?.date?.end ? `api.setEndDate(new Date(${endYear}, ${ Number(endMonth) - 1}, ${ Number(endDay)}));` : ''}

                    ${ props.formData?.guests?.adults ? `api.setAdultCount(${props.formData?.guests?.adults});` : '' }
                    ${ props.formData?.guests?.kids ? `api.setChildCount(${props.formData?.guests?.kids});` : '' }

                    ${ code ? `api.setVoucherCode('${code}');` : '' }

                    ${ props.roomId !== '' ? `api.showRates('${props.roomId}');` : null }

                    // if date has been selected, showRooms step, otherwise the default/first step
                    ${ props.formData?.date?.start && props.formData?.date?.end ? 'api.showRooms();' : '' }

                    ${ props.mewsIds?.length ? 'api.showHotels()' : '' }

                    api.open();
                });`
            }
        ]}
    );
});
</script>
